import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { useToaster } from "@insite/mobius/Toast/ToasterContext";
import * as React from "react";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export const passwordExpirationStorageKey = "passwordExpirationWarningDays";

const PasswordExpirationWarning: React.FC = () => {
    const toaster = useToaster();
    const isSessionLoaded = useSelector((state: ApplicationState) => state.context.isSessionLoaded);
    const [toastShown, setToastShown] = useState(false);

    useEffect(() => {
        if (IS_SERVER_SIDE || !isSessionLoaded || toastShown) {
            return;
        }

        const storedValue = sessionStorage.getItem(passwordExpirationStorageKey);
        if (!storedValue) {
            return;
        }

        sessionStorage.removeItem(passwordExpirationStorageKey);
        setToastShown(true);

        const expiresInDays = parseInt(storedValue, 10);
        const message =
            expiresInDays <= 0
                ? siteMessage("PasswordExpiration_Expired")
                : expiresInDays === 1
                ? siteMessage("PasswordExpiration_ExpiresTomorrow")
                : siteMessage("PasswordExpiration_ExpiresInDays", storedValue);

        toaster.addToast({ body: message, messageType: "warning", timeoutLength: 10000 });
    }, [isSessionLoaded]);

    return null;
};

export default PasswordExpirationWarning;
